/**
 * Caveat, the hand-written face of the hero tagline, registered from script after
 * the first paint instead of by an @font-face in the CSS.
 *
 * Declared in CSS, the browser fetched its 51 KB at the highest priority during
 * the first style pass — on slow 4G, sharing the line with the hero image the LCP
 * waits for, for one decorative line. It was already `font-display: swap`, so the
 * tagline looked the same either way: drawn in the fallback script face first,
 * then swapped. Only the timing of the download moves.
 */
const CAVEAT = {
  family: "Caveat",
  src: 'url("/fonts/caveat/caveat-latin-600-normal.woff2") format("woff2")',
  descriptors: {
    weight: "600",
    style: "normal",
    display: "swap",
    unicodeRange:
      "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
  } satisfies FontFaceDescriptors,
};

let registered = false;

export function loadScriptFont(): void {
  if (registered || typeof FontFace === "undefined") return;
  registered = true;
  const face = new FontFace(CAVEAT.family, CAVEAT.src, CAVEAT.descriptors);
  document.fonts.add(face);
  void face.load().catch(() => {
    // The fallback script face is the designed fallback; nothing to recover.
  });
}
